import { useState } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import { bridge, isUnderAge14 } from 'shared/src/utils';
import { BirthdaySelector } from './BirthdaySelector';
import { usePatchMyInfo } from './queries/usePatchMyInfo';

/**
 * 가입완료 드로어의 생년월일 입력. 선택 즉시 만14세 미만 차단 후 저장한다.
 * (webview BirthdateForm 대응 — 선택=저장, 별도 제출 버튼 없음)
 */
export const BirthdayForm = () => {
  const { mutateAsync: patchMyInfo } = usePatchMyInfo();
  const [date, setDate] = useState('');

  const handleChange = async (selected: string) => {
    if (selected === '') return;
    if (isUnderAge14(selected)) {
      bridge.toast('만 14세 이상만 가입 가능해요');
      return;
    }
    try {
      await patchMyInfo({ birth_date: selected });
      // 저장 성공 후에만 반영 — 실패 시 필드가 이전 값으로 남아 재시도 가능.
      setDate(selected);
    } catch {
      bridge.toast('생년월일 저장에 실패했어요');
    }
  };

  return (
    <Flex gap={8}>
      <Typography type={'subtitle2'} color={'content_primary'}>
        {'생년월일'}
      </Typography>
      <BirthdaySelector value={date} onChange={handleChange} />
    </Flex>
  );
};
